import { Wifi, BatteryFull, Search, Mic, RefreshCw, BatteryMedium } from 'lucide-react';

export default function SeaCloudMuteMockup() {
  return (
    <div className="app-mockup">
      <div className="app-mockup-menubar">
        <div className="app-mockup-menubar-left">seacloud mute</div>
        <div className="app-mockup-menubar-right">
          <Search size={13} strokeWidth={2} />
          <Wifi size={13} strokeWidth={2} />
          <span className="app-mockup-menubar-icon-active">
            <Mic size={13} strokeWidth={2.2} />
          </span>
          <BatteryFull size={15} strokeWidth={1.8} />
        </div>
      </div>

      <div className="app-mockup-popover">
        <div className="app-mockup-popover-header">
          <span className="app-mockup-headset-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M9 18v-6a3 3 0 0 1 6 0v6a2.5 2.5 0 0 1-5 0v-4" strokeLinecap="round" />
              <circle cx="6.5" cy="9" r="2.5" />
              <circle cx="17.5" cy="9" r="2.5" />
            </svg>
          </span>
          <span className="app-mockup-title">AirPods Pro 2</span>
          <RefreshCw size={13} strokeWidth={2} className="app-mockup-refresh" />
        </div>

        <div className="app-mockup-popover-body">
          <div className="app-mockup-label">Battery</div>
          <div className="app-mockup-battery-row">
            <BatteryFull size={16} className="app-mockup-batt-good" />
            <span className="app-mockup-batt-label">Left</span>
            <span className="app-mockup-batt-value app-mockup-batt-good">91%</span>
          </div>
          <div className="app-mockup-battery-row">
            <BatteryFull size={16} className="app-mockup-batt-good" />
            <span className="app-mockup-batt-label">Right</span>
            <span className="app-mockup-batt-value app-mockup-batt-good">88%</span>
          </div>
          <div className="app-mockup-battery-row">
            <BatteryMedium size={16} className="app-mockup-batt-mid" />
            <span className="app-mockup-batt-label">Case</span>
            <span className="app-mockup-batt-value app-mockup-batt-mid">64%</span>
          </div>
        </div>

        <button type="button" className="app-mockup-mute-btn">
          <Mic size={14} strokeWidth={2} />
          Mute Microphone
        </button>
      </div>
    </div>
  );
}
